import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Tools::ImageText::Modal @composer={{@composer}} @onClose={{@onClose}} @onSubmit={{@onInsert}} @isEditing={{false}} data-test-imagetext-inserter />", {
  moduleName: "@intercom/embercom-prosemirror-composer/components/tools/image-text-inserter.hbs"
});